<template>
  <cs-view single-view>
    <template #content>
      <excursion-stepper v-if="showExcursionStepper"></excursion-stepper>
      <excursion-builder v-else prop-has-parent-component></excursion-builder>
    </template>
  </cs-view>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { CSBase } from '@complispace/cs-design-system';
import { mapState } from 'vuex';
import excursionStatus from '../lib/const/excursionStatus';
import ExcursionStepper from './ExcursionStepper';
import ExcursionBuilder from './ExcursionBuilder';

export default {
  name: 'SafeTripBuilder',

  components: {
    ExcursionStepper,
    ExcursionBuilder
  },
  extends: CSBase,

  data() {
    return {};
  },

  computed: {
    ...mapState({
      showExcursionStepper: (state) => state.common.showExcursionStepper,
      createAndUpdateExcursionEnabled: (state) => state.common.createAndUpdateExcursionEnabled,
      excursionCreationButtonDisplayed: (state) => state.common.excursionCreationButtonDisplayed,
      isAuthenticated: (state) => state.authorisation.isAuthenticated,
      excursionConfig: (state) => state.excursions.excursionConfig
    })
  },

  watch: {
    showExcursionStepper() {
      this.$store.dispatch('common/setLogoImgUrl');
    }
  },
  async mounted() {
    await this.initView();
  },

  beforeUnmount() {
    // Remove the resize event listener
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    async initView() {
      const { query, params } = this.$route;
      const { axiosInstance, eventPluginCommonAdapter, stbApiAdapter } = this.$app;
      const isVendorAuthScheme =
        !!this.$route.query['vendor-sid'] && !!this.$route.query['oauth-signature'];
      const queryParam = isVendorAuthScheme ? this.$route.query : {};
      if (!isVendorAuthScheme) {
        await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
          query: this.$route.query,
          axiosInstance
        });
        if (this.$route.params?.id > 0) {
          queryParam['excursion-id'] = this.$route.params.id;
        }
      }
      await this.$store.dispatch('common/initClientConfig', {
        queryParam,
        eventPluginCommonAdapter,
        stbApiAdapter
      });
      if (
        this.isAuthenticated &&
        !this.excursionCreationButtonDisplayed &&
        this.$route.name === 'SafeTripBuilderNewRecord'
      ) {
        this.$router.replace('/excursions');
        return;
      }
      this.$store.dispatch('common/setLogoImgUrl');

      if (query.referrer || query['vendor-sid'] || query['oauth-signature']) {
        window.addEventListener('resize', this.handleResize);
      }

      const excursionId = params && params.id ? params.id : '0';
      const store = this.$store;
      const app = this.$app;

      const that = this;
      if (this.isAuthenticated) {
        const getExcursionsArgHash = {
          stbApiAdapter: app.stbApiAdapter,
          store,
          excursionId,
          query
        };
        await store.dispatch('excursions/fetchExcursionConfig', {
          excursionId,
          queryParams: query
        });
        await store.dispatch('common/getExcursions', getExcursionsArgHash);
        const argHash = {
          stbApiAdapter: app.stbApiAdapter,
          store,
          queryParam: query
        };

        const resolvedExcursionStatus = store.state.common.excursionDc.status;
        // check archive status
        const archivedExcursionDetected = excursionStatus.ARCHIVED === resolvedExcursionStatus;
        const clientSid = store.state.common.userClientSid;
        if (!archivedExcursionDetected) {
          await this.$store.dispatch('excursions/fetchExcursionTypes', {
            params: query,
            clientSid
          });
        }

        if (
          excursionId !== '0' &&
          this.excursionConfig?.student?.isStudentSelectionEnabled &&
          !archivedExcursionDetected
        ) {
          const medicalConditionsResponse = await this.$store.dispatch(
            'excursions/fetchExcursionMedicalConditions',
            {
              excursionId: this.$store.state.common.excursionDc.id,
              queryParams: query
            }
          );
          const { studentMedicalConditions } = medicalConditionsResponse;
          const remoteMedicalConditions = studentMedicalConditions.map(({ name, isSupported }) => ({
            name,
            supported: isSupported
          }));

          this.$store.commit(
            types.COMMON_SET_EXCURSION_STUDENT_MEDICAL_CONDITIONS,
            remoteMedicalConditions
          );
        }

        if (!that.createAndUpdateExcursionEnabled) {
          store.commit(types.COMMON_SET_SHOW_EXCURSION_STEPPER, false);
        } else if (!archivedExcursionDetected) {
          store.dispatch('common/updateProviders', argHash);
        }

        const excursionTypeName = store.state.common.excursionDc.typeId;
        try {
          await store.dispatch('common/getAllRisksByExcursionTypeName', {
            stbApiAdapter: app.stbApiAdapter,
            store,
            queryParam: query,
            excursionTypeName
          });
        } catch {
          // v1 404s for unsupported types; v2 decides the real user-facing message — see stbApi.getRisks
        }
        if (excursionTypeName) {
          const apiQuery = { ...query, excursionType: excursionTypeName };
          await this.$store.dispatch('excursions/fetchExcursionRiskCategories', {
            params: apiQuery,
            clientSid
          });
        }
        if (!archivedExcursionDetected) {
          await store.dispatch('common/getDefaultJurisdiction', {
            stbApiAdapter: app.stbApiAdapter,
            store,
            queryParam: query,
            excursionTypeName
          });
        }
      }

      window.onbeforeunload = function () {
        if (window.opener) {
          window.opener.postMessage('refresh', '*');
          window.self.close();
        }
      };
    },
    handleResize() {
      const w = 960;
      const h = window.screen.availHeight;
      window.resizeTo(w, h);
    }
  }
};
</script>
